//初始化：
import { getLocalUserData } from '../components/UserData/user';

//初始化：
const tracker = window.LXAnalytics('getTracker');
//进入首页时：
const page_home = tracker('pageView', {}, {}, 'home');
export function sendFileLx(fileName) {
  //文件下载埋点
  const { mtUid } = getLocalUserData();
  page_home('moduleClick', 'file_download', { fileName: decodeURIComponent(fileName), mtUid });
}

export function sendPv(uid) {
  window.LXAnalytics('set', 'uid', uid);
  window.LXAnalytics('pageView', null, null, 'c_waimai_greentech_c');
}
